import * as React from "react";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { AnalyticsStore } from "bernie-core";
import { CompositionStore } from "src/stores/CompositionStore";
import { inject } from "mobx-react";
import { FlexTrackingInfo, Action, sendImmediateTrackEvent } from "./FlexAnalyticsUtils";
import { MABMicroMessage, getMABMicroMessage, MABPlatform, isMABEnabled } from "./MABAnalyticsUtils";

export interface MabTrackerProps {
  analytics?: AnalyticsStore;
  compositionStore?: CompositionStore;
  context?: ExtendedContextStore;
  [x: string]: any;
}

export interface MabTrackEvent {
  moduleName: string;
  rfrr: string;
  eventTarget: string;
  eventType: string;
}

const withMabTracker = (WrappedComponent: any) => {
  const MabTracker = inject(
    "context",
    "analytics",
    "compositionStore"
  )((props: MabTrackerProps) => {
    const { analytics, compositionStore, context } = props;

    const trackEvent = (eventProps: MabTrackEvent) => {
      const { moduleName, rfrr, eventTarget, eventType } = eventProps;
      if (!analytics || !compositionStore || !context) {
        // tslint:disable-next-line:no-console
        console.log(`Some store is not presented`);

        return;
      }
      const banditContext = compositionStore.composition?.bandit;
      if (banditContext) {
        const trackingInfo: FlexTrackingInfo = {
          moduleName,
          rfrr,
          action: Action.CLICK,
        };
        const {
          deviceInformation,
          site: { domain: pos },
        } = context;
        const { mobile, tablet } = deviceInformation || {};
        const mabTrackingInfo: MABMicroMessage = getMABMicroMessage(
          banditContext,
          eventTarget,
          eventType,
          mobile ? MABPlatform.Mobile : tablet ? MABPlatform.Tablet : MABPlatform.Desktop,
          pos
        );
        sendImmediateTrackEvent(trackingInfo, analytics, mabTrackingInfo);
      } else {
        // tslint:disable-next-line:no-console
        console.log(`Bandit or MAB experiment is not presented`);
      }
    };

    if (context && isMABEnabled(context)) {
      return <WrappedComponent {...props} mabTrack={trackEvent} />;
    }

    return <WrappedComponent {...props} />;
  });

  return MabTracker;
};

export { withMabTracker };
